import React, { useEffect } from 'react';
import Script from 'next/script';

export interface GoogleAdProps {
  /**
   * Google AdSense ad slot ID
   * Example: '1234567890'
   */
  adSlot: string;
  
  /**
   * Additional CSS class name for the container
   */
  className?: string;
}

/**
 * GoogleAd Component
 * 
 * A simple wrapper for Google AdSense ads that follows Google's policies.
 * Do not modify the ad code or interfere with ad behavior.
 */
export const GoogleAd: React.FC<GoogleAdProps> = ({ 
  adSlot, 
  className = ''
}) => {
  useEffect(() => {
    try {
      // Simple ad initialization as per Google's guidelines
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, [adSlot]);

  return (
    <div className={className}>
      <Script
        id={`adsense-${adSlot}`}
        strategy="afterInteractive"
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3342005132738931"
        crossOrigin="anonymous"
      />
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-3342005132738931"
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default GoogleAd;
